var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33398 9.00016H7.66732V10.3335H6.33398V9.00016ZM6.33398 3.66683H7.66732V7.66683H6.33398V3.66683ZM6.99398 0.333496C3.31398 0.333496 0.333984 3.32016 0.333984 7.00016C0.333984 10.6802 3.31398 13.6668 6.99398 13.6668C10.6807 13.6668 13.6673 10.6802 13.6673 7.00016C13.6673 3.32016 10.6807 0.333496 6.99398 0.333496ZM7.00065 12.3335C4.05398 12.3335 1.66732 9.94683 1.66732 7.00016C1.66732 4.0535 4.05398 1.66683 7.00065 1.66683C9.94732 1.66683 12.334 4.0535 12.334 7.00016C12.334 9.94683 9.94732 12.3335 7.00065 12.3335Z",
    fill: "#74A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueError);
export default __webpack_public_path__ + "static/media/blue_error.0e0a2a9ef8a0938b48f548dddd862bc9.svg";
export { ForwardRef as ReactComponent };